export default "__VITE_ASSET__DCh6nO5f__"